import React from 'react';
import { Modal } from './Modal';
import { Button } from './Button';
import { WarningIcon, TrashIcon } from './Icons';

export const DeleteConfirmModal = ({ isOpen, onClose, onConfirm, notificationTitle }) => {
  const footer = (
    <>
      <Button variant="ghost" onClick={onClose} className="mr-auto">
        Cancel
      </Button>
      <Button variant="danger" onClick={onConfirm} icon={<TrashIcon />}>
        Delete Notification
      </Button>
    </>
  );

  return (
    <Modal isOpen={isOpen} onClose={onClose} title="Delete Notification" footer={footer} size="small">
      <div className="text-center py-5">
        <div className="w-14 h-14 bg-red-100 rounded-full flex items-center justify-center mx-auto mb-4 text-red-500">
          <WarningIcon size={24} />
        </div>
        <p className="text-slate-600 leading-relaxed">
          Are you sure you want to delete{notificationTitle ? ` "${notificationTitle}"` : ' this notification'}? 
          This action cannot be undone.
        </p>
      </div>
    </Modal>
  );
};
